import { useUiStateStore } from '@/@core/services/uiStateStore';
import { reactive, toRefs } from '@vue/composition-api';
import { useInfographicStore } from '../../services/store';

type InfographicModelState = {
  headers: any[];
  isLoading: boolean;
  showFormDialog: boolean;
  showDeleteDialog: boolean;
  isFormValid: boolean;
  formData: any;
  search: string;
};

const state = reactive<InfographicModelState>({
  headers: [
    {
      text: 'File',
      value: 'path'
    },
    {
      text: 'Caption',
      value: 'caption'
    },
    {
      text: '',
      value: 'actions',
      sortable: false,
      width: '1%'
    }
  ],
  isLoading: false,
  showFormDialog: false,
  showDeleteDialog: false,
  isFormValid: false,
  formData: null,
  search: ''
});

export default function useInfographicModel() {
  const store = useInfographicStore();

  const onGetManyInfographic = async () => {
    state.isLoading = true;

    try {
      state.isLoading = true;
      await store.getManyInfographic();
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const onCreateInfographic = async (data: any) => {
    state.isLoading = true;

    try {
      const success = await store.postInfographic(data);
      if (!success) return

      useUiStateStore().createSnackbar({
        message: `Infografis ${data.event} berhasil ditambahkan.`
      });

      state.showFormDialog = false;
      await onGetManyInfographic();
      state.formData = null;
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const onUpdateInfographic = async (data: any) => {
    state.isLoading = true;

    try {
      const success = await store.putInfographic(data);
      if (!success) return
      useUiStateStore().createSnackbar({
        message: `Infografis ${data.event} berhasil diubah.`
      });
      state.showFormDialog = false;
      await onGetManyInfographic();
      state.formData = null;
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const createInfographic = () => {
    state.formData = null;
    state.showFormDialog = true;
  };

  const editInfographic = (infographic: any) => {
    state.formData = { ...infographic };
    if (infographic.startAt) state.formData.startAt = new Date(infographic.startAt).toISOString().slice(0, 10);
    if (infographic.endAt) state.formData.endAt = new Date(infographic.endAt).toISOString().slice(0, 10);

    state.showFormDialog = true;
  };

  const deleteInfographic = (infographic: any) => {
    state.formData = infographic;
    state.showDeleteDialog = true;
  };

  const onDeleteInfographic = async () => {
    state.isLoading = true;

    try {
      const success = await store.deleteInfographic(state.formData);
      if (!success) return

      const data: any = state.formData || {};
      useUiStateStore().createSnackbar({
        message: `Infografis ${data.event} berhasil dihapus.`
      });
      state.showDeleteDialog = false;
      state.formData = null;
      await onGetManyInfographic();
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const onSubmitForm = () => {
    const isEdit = (state.formData as any)?.id;

    if (isEdit) onUpdateInfographic(state.formData);
    else onCreateInfographic(state.formData);
  };

  return {
    ...toRefs(state),
    store,
    onGetManyInfographic,
    onSubmitForm,
    onDeleteInfographic,
    deleteInfographic,
    editInfographic,
    createInfographic
  };
}

export { useInfographicModel };
